import { render, staticRenderFns } from "./MachineAdd.vue?vue&type=template&id=4a1c0060&"
import script from "./MachineAdd.vue?vue&type=script&lang=js&"
export * from "./MachineAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports